// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrap":"GlobalLoading_spinnerWrap__1Ak1V","spinner":"GlobalLoading_spinner__2eNQ0"};